export default "/images/flags.png?1db778095ed6fb63677b11463743ec0b";